'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { NotFound } from '@/components/Error/NotFound';
import { VStack } from '@/components/Layout';
import { featureFlags } from '@/lib/env';
export const Route = createFileRoute('/_chat')({
  component: ChatLayout
});

// topbar / 背景色はページ側が描画する（cockpit / individual で見た目が分岐するため）。
function ChatLayout() {
  if (!featureFlags.check('LABOR_PLUS_MOCK')) {
    return <NotFound />;
  }
  return <VStack className="fixed inset-0 overflow-hidden">
      <Outlet />
    </VStack>;
}